import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerPlans: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { plansRequestHandler } = await import("./mocks/plansRequestHandler.ts");

        runtime.registerRequestHandlers([plansRequestHandler]);
    }
};
